import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Developer signature
(function(){
  var c = document.createComment('\n  Desarrollo realizado por We Are DataLab. Contactenos en https://wearedatalab.com\n  Development made by We Are DataLab. Contact us at https://wearedatalab.com\n');
  document.documentElement.parentNode.insertBefore(c, document.documentElement);
  console.log("%c██╗    ██╗███████╗     █████╗ ██████╗ ███████╗    ██████╗  █████╗ ████████╗ █████╗ ██╗      █████╗ ██████╗ \n██║    ██║██╔════╝    ██╔══██╗██╔══██╗██╔════╝    ██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗██║     ██╔══██╗██╔══██╗\n██║ █╗ ██║█████╗      ███████║██████╔╝█████╗      ██║  ██║███████║   ██║   ███████║██║     ███████║██████╔╝\n██║███╗██║██╔══╝      ██╔══██║██╔══██╗██╔══╝      ██║  ██║██╔══██║   ██║   ██╔══██║██║     ██╔══██║██╔══██╗\n╚███╔███╔╝███████╗    ██║  ██║██║  ██║███████╗    ██████╔╝██║  ██║   ██║   ██║  ██║███████╗██║  ██║██████╔╝\n ╚══╝╚══╝ ╚══════╝    ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚═════╝", "color: #000; font-family: monospace; font-size: 10px;");
  console.log("%cDesign by wearedatalab.com — Contact us: https://wearedatalab.com", "color: #97EA3F; font-size: 13px; font-weight: bold;");
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
